import { observer } from "mobx-react-lite";
import Link from "next/link";
import { useTranslations } from "next-intl";

import { useHintHover } from "@/components/hints/useHintHover";
import { useStore } from "@/store";
import { docPageUrl, teamPageUrl } from "@/urls";
import { twMerge } from "@/utils/twMerge";

import { useTreeItemControlTabIndex } from "../useSidebarNav";

export const ProfileButton = observer(() => {
  const t = useTranslations("documentsSidebar");
  const { documentTree } = useStore();
  const hintHandlers = useHintHover("profilePreview");

  if (!documentTree.currentTeam) {
    return null;
  }

  const firstPublishedFile = documentTree.published?.files?.find(
    (file) => file.typename === "DocumentShort",
  );
  const href = firstPublishedFile
    ? docPageUrl({ docId: firstPublishedFile.uid, preview: true })
    : teamPageUrl({ teamPermalink: documentTree.currentTeam.permalink, preview: true });

  const controlTabIndex = useTreeItemControlTabIndex();

  return (
    <Link
      href={href}
      tabIndex={controlTabIndex}
      className={twMerge(
        "right-button",
        "inline-flex rounded-6 my-[5px] mr-[5px] px-2 py-1 font-geist text-[14px] leading-[18px] tracking-tight bg-document-bg shadow-block text-blue-500 whitespace-nowrap",
        "hover:opacity-60 active:opacity-40",
      )}
      {...hintHandlers}
    >
      {t("preview")}
    </Link>
  );
});
